'use client'

import { App as AntdApp, ConfigProvider, ThemeConfig } from 'antd'
import { prepareTheme, ThemeContext, ThemeContextValueType } from 'context/theme.context'
import { PropsWithChildren, useMemo, useState } from 'react'


export const AntdProvider = ({ children }: PropsWithChildren) => {
  const [sideMenuTheme, setSideMenuTheme] = useState<ThemeConfig>(() => prepareTheme())
  const [toolbarTheme, setToolbarTheme] = useState<ThemeConfig>(() => prepareTheme())
  const [theme, setTheme] = useState<ThemeConfig>(() => prepareTheme())

  const themeContextValue = useMemo<ThemeContextValueType>(() => ({
    customize: (options) => setTheme(prepareTheme(options)),
    customizeSideMenu: (options) => setSideMenuTheme(prepareTheme(options)),
    customizeToolbar: (options) => setToolbarTheme(prepareTheme(options)),
    sideMenuTheme,
    theme,
    toolbarTheme,
  }), [theme, sideMenuTheme, toolbarTheme])

  return (
    <ThemeContext.Provider value={themeContextValue}>
      <ConfigProvider theme={theme}>
        <AntdApp>
          {children}
        </AntdApp>
      </ConfigProvider>
    </ThemeContext.Provider>
  )
}
